import { createMemoryHistory, createRouter, createWebHistory } from 'vue-router';
import { commodityInnerControllerListCommodityInfo } from '@api/CoolPlan2nd/paths/schemas';
import { tubeInnerControllerGetHeadTube, tubeOuterControllerGetHeadTube } from '@api/ShortSeries/paths/schemas';
import {
    shelfCommodityInnerControllerListShelfCommodityInfo,
    shelfCommodityOuterControllerListShelfCommodityInfo,
} from '@api/eCommerce/paths/schemas';

export const base = '';
export const RouteName = {
    COOL_PLAN: {
        HOME: 'cool-plan-home',
        ERROR: 'cool-plan-error',
        GROUND: 'cool-plan-ground',
    },
    SHORT_SERIES: {
        HOME: 'short-series-home',
        OUTER: 'short-series-outer',
        ERROR: 'short-series-error',
    },
    E_COMMERCE: {
        HOME: 'e-commerce-home',
        OUTER: 'e-commerce-outer',
        ERROR: 'e-commerce-error',
    },
};

export const routes = [
    {
        path: '/cool-plan',
        children: [
            {
                path: 'home',
                name: RouteName.COOL_PLAN.HOME,
                component: () => import('@/pages/cool-plan/old-home/HomePage.vue'),
                meta: {
                    title: '首页',
                    LOG_PAGE: 'UG_BENDI_GOODS_LIST_H5',
                    FMP_URLS: [commodityInnerControllerListCommodityInfo.path],
                    HIDE_LOADING: false,
                },
            },
            {
                path: 'error',
                name: RouteName.COOL_PLAN.ERROR,
                component: () => import('@/pages/cool-plan/error/ErrorPage.vue'),
                meta: {
                    title: '首页',
                    LOG_PAGE: 'ACTIVITY_ERROR',
                    HIDE_LOADING: true,
                },
            },
            {
                path: 'cbd',
                redirect: '/cool-plan/ground',
            },
            {
                path: 'ground',
                name: RouteName.COOL_PLAN.GROUND,
                component: () => import('@/pages/cool-plan/ground/GroundPage.vue'),
                meta: {
                    title: '首页',
                    LOG_PAGE: 'UG_BENDI_GOODS_LIST_TY_H5',
                    FMP_URLS: [commodityInnerControllerListCommodityInfo.path],
                    HIDE_LOADING: false,
                },
            },
        ],
    },
    {
        path: '/short-series',
        children: [
            {
                path: 'home',
                name: RouteName.SHORT_SERIES.HOME,
                component: () => import('@/pages/short-series/home/HomePage.vue'),
                meta: {
                    title: '首页',
                    LOG_PAGE: 'OP_ACTIVITY_UG_SPLAY_LIST_H5',
                    FMP_URLS: [tubeInnerControllerGetHeadTube.path],
                    HIDE_LOADING: false,
                },
            },
            {
                path: 'outer',
                name: RouteName.SHORT_SERIES.OUTER,
                component: () => import('@/pages/short-series/outer/OuterPage.vue'),
                meta: {
                    title: '首页',
                    LOG_PAGE: 'OP_ACTIVITY_UG_SPLAY_OUT_DOWNLOAD_H5',
                    FMP_URLS: [tubeOuterControllerGetHeadTube.path],
                    HIDE_LOADING: false,
                },
            },
            {
                path: 'error',
                name: RouteName.SHORT_SERIES.ERROR,
                component: () => import('@/pages/short-series/error/ErrorPage.vue'),
                meta: {
                    title: '首页',
                    LOG_PAGE: 'ACTIVITY_ERROR',
                    HIDE_LOADING: true,
                },
            },
        ],
    },
    {
        path: '/e-commerce',
        children: [
            {
                path: 'home',
                name: RouteName.E_COMMERCE.HOME,
                component: () => import('@/pages/e-commerce/home/HomePage.vue'),
                meta: {
                    title: '首页',
                    LOG_PAGE: 'UG_ECOMMERCE_GOODS_LIST_H5',
                    FMP_URLS: [shelfCommodityInnerControllerListShelfCommodityInfo.path],
                    HIDE_LOADING: false,
                },
            },
            {
                path: 'outer',
                name: RouteName.E_COMMERCE.OUTER,
                component: () => import('@/pages/e-commerce/outer/OuterPage.vue'),
                meta: {
                    title: '首页',
                    LOG_PAGE: 'UG_ECOMMERCE_OUT_DOWNLOAD_H5',
                    FMP_URLS: [shelfCommodityOuterControllerListShelfCommodityInfo.path],
                    HIDE_LOADING: false,
                },
            },
            {
                path: 'error',
                name: RouteName.E_COMMERCE.ERROR,
                component: () => import('@/pages/e-commerce/error/ErrorPage.vue'),
                meta: {
                    title: '首页',
                    LOG_PAGE: 'ACTIVITY_ERROR',
                    HIDE_LOADING: true,
                },
            },
        ],
    },
];
export const createAppRouter = () =>
    createRouter({
        history: import.meta.env.SSR ? createMemoryHistory(base) : createWebHistory(base),
        routes,
    });
